export enum HeadCellSortState {
  Asc = 'ascending',
  Desc = 'descending',
  None = '',
}

export const toggleSortStates = (state: HeadCellSortState): HeadCellSortState => {
  return state === HeadCellSortState.Asc ? HeadCellSortState.Desc : HeadCellSortState.Asc;
};
